import React from 'react';
import { ResultModal } from './v2/ResultModal.styles';
import ProfessionRiskCard from '../Cards/ProfessionRiskCard';
import AragCard from '../Cards/AragCard';
import QuotationCard from '../../../reusable/QuotationCard';
import { capitalizeTitle } from './ResultPageModal';

function ProfessionModal({
  type,
  addingQuote,
  quotations,
  userData,
  profession,
  extensions,
  requestToken,
  selectableExtensions,
  docs,
  set_informativi,
  selectQuotation,
}) {
  return (
    <ResultModal
      className="modal fade"
      id={type.id}
      tabIndex="-1"
      aria-labelledby={type.name}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id={type.name}>
              {capitalizeTitle(type.name)}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="buttonClose"
            />
          </div>
          <div className="modal-body">
            {addingQuote && (
              <div className="d-flex align-items-center justify-content-between flex-column">
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">
                      Aggiungendo...
                    </span>
                  </div>
                </div>
                <div className="ms-2">Aggiungendo...</div>
              </div>
            )}
            {addingQuote === false && quotations[type.id]
              ? quotations[type.id].map((quote, index) => (
                <div className="mt-3" key={index}>
                  {quote.quote_type === 'res_civile' ? (
                    <QuotationCard
                      requestInfo={userData}
                      quote={quote}
                      set_informativi={set_informativi}
                      docs={docs}
                      extensions={extensions}
                      requestToken={requestToken}
                      selectableExtensions={selectableExtensions}
                      profession={profession}
                      selectQuotation={selectQuotation}

                    />
                  ) : quote.company_id === 15 ? (
                    <AragCard
                      quotation={quote}
                      requestInfo={userData}
                      type={type}
                      selectQuotation={selectQuotation}
                    />
                  ) : (
                    <ProfessionRiskCard
                      quote={quote}
                      requestInfo={userData}
                      selectQuotation={selectQuotation}
                      professionId={profession?.profession}
                      type={type}
                      profession={profession}
                    />
                  )}
                </div>
              ))
              : addingQuote === false && (
                <p>
                  {`Nessuna Quotazione ${type.name} Trovata.`}
                </p>
              )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger px-4"
              data-bs-dismiss="modal"
            >
              Chiudi
            </button>
          </div>
        </div>
      </div>
    </ResultModal>
  );
}

export default ProfessionModal;
